import clsx from "clsx";
import { FunctionComponent, JSX } from "react";

import { type MetaVariation } from "@ui/components/content-cards/ContentBlock";
import { sharedStyles } from "@ui/shared-styles";

interface Props {
  label: string;
  icon?: JSX.Element;
  metaVariation?: MetaVariation;
  className?: string;
}

const ContentBlockLabel: FunctionComponent<Props> = ({
  label,
  icon,
  metaVariation = "standard",
  className,
}) => {
  return (
    <span
      className={clsx(
        sharedStyles.text.metaTextVariant[metaVariation],
        className,
      )}
    >
      {icon && icon}
      {label}
    </span>
  );
};

export default ContentBlockLabel;
